export const ROOT_CONTEXT = "/walmartconnect"
export const LOGIN_LANDING = "/login-landing"
export const PINGFED_CALLBACK = "/auth-pingfed"
export const PHRONESIS_LOGIN = "/phronesis-login"
export const PHRONESIS_LOGIN_CALLBACK = "/auth-phronesis"
export const RESET_PW = "/reset-password"
export const CHANGE_PW = "/change-password"
export const HOME = "/"
export const TRANSACTIONAL = "/transactional"
export const TRANSACTIONAL_GEOGRAPHIC = "/transactional/geographic"
export const TRANSACTIONAL_COMMERCIAL = "/transactional/commercial"
export const TRANSACTIONAL_BENCHMARK = "/transactional/benchmark"
export const TRANSACTIONAL_BENCHMARK_BY_TOTAL_SALES =
	"/transactional/benchmark/total-sales"
export const TRANSACTIONAL_BENCHMARK_BY_CHANNELS =
	"/transactional/benchmark/by-channels"
export const TRANSACTIONAL_BENCHMARK_BY_FORMATS =
	"/transactional/benchmark/by-formats"
export const TRANSACTIONAL_BENCHMARK_BY_LOCATION =
	"/transactional/benchmark/by-location"
export const TRANSACTIONAL_BENCHMARK_BY_BRANDS =
	"/transactional/benchmark/by-brands"
export const TRANSACTIONAL_OPERATIONAL = "/transactional/operational"
export const TRANSACTIONAL_CROSS_SELLING = "/transactional/cross-selling"
export const TRANSACTIONAL_VALUE_SHARED_MODEL =
	"/transactional/value-shared-model"
export const PERFORMANCE_GROWTH_PROFILING = "/transactional/growth-profiling"
export const CUSTOMER_BEHAVIOR = "/customer-behavior"
export const CUSTOMER_BEHAVIOR_HABITS = "/customer-behavior/habits"
export const CUSTOMER_BEHAVIOR_CLUSTERING = "/customer-behavior/clustering"
export const CUSTOMER_BEHAVIOR_SWITCHING_BREAKDOWN =
	"/customer-behavior/switching-breakdown"
export const CUSTOMER_BEHAVIOR_SWITCHING_SWITCHING_BY_PRODUCTS =
	"/customer-behavior/switching-by-products"
export const CUSTOMER_BEHAVIOR_SWITCHING_SWITCHERS_OUT =
	"/customer-behavior/switching-out"
export const CUSTOMER_BEHAVIOR_PROFILING = "/customer-behavior/profiling"
export const CUSTOMER_BEHAVIOR_LOYALTY = "/customer-behavior/loyalty"
export const CUSTOMER_BEHAVIOR_LOYALTY_EVOLUTION =
	"/customer-behavior/loyalty/loyalty-evolution"
export const CUSTOMER_BEHAVIOR_LOYALTY_FILL_RATE =
	"/customer-behavior/loyalty/loyalty-fill-rate"
export const CUSTOMER_BEHAVIOR_PLATFORM = "/customer-behavior/platform"
export const CUSTOMER_BEHAVIOR_SENSITIVITY = "/customer-behavior/sensitivity"
export const PREDICTIVE_CENTER = "/predictive-center"
export const OPERATIONS = "/operations"
export const OPERATIONS_STORE_SHORTAGES = "/operations/store-shortages"
export const PREDICTIVE_CENTER_PRODUCT_RECOMMENDATION =
	"/operations/store-shortages"
export const PREDICTIVE_CENTER_BRANDING_AND_PRODUCT_CHURN =
	"predictive-center/branding-and-product-churn"
export const PREDICTIVE_CENTER_COVERAGE_PREDICTION =
	"predictive-center/coverage-prediction"
export const PREDICTIVE_CENTER_PREDICTIVE_ASSORTMENTS =
	"predictive-center/predictive-assortments"
export const PREDICTIVE_CENTER_PROPENSITY_STUDIES =
	"predictive-center/propensity-studies"
export const PREDICTIVE_CENTER_PURCHASE_DRIVERS =
	"predictive-center/purchase-drivers"
export const ADVERTISEMENT_CENTER = "/advertisement-center"
export const LABS = "/labs"
export const LABS_VALUE_SHARE_MODEL = "/labs/value-share-model"
export const LABS_CROSS_SELLING = "/labs/cross-selling"
export const LABS_CROSS_SELLING_PROPICIADAS = "/labs/cross-selling/propiciadas"
export const LABS_CROSS_SELLING_PROPICIADORAS =
	"/labs/cross-selling/propiciadoras"
export const LABS_VSM_SUMMARY = "/labs/value-share-model/summary"
export const LABS_VSM_CUSTOMER_PENETRATION =
	"/labs/value-share-model/customer-penetration"
export const LABS_VSM_EXPENSE_RATE = "/labs/value-share-model/expense-rate"
export const LABS_VSM_CLOSE_RATE = "/labs/value-share-model/close-rate"
export const ADVERTISEMENT_CENTER_MEDIA_CAMPAIGNS =
	"/advertisement-center/media-campaigns"
export const ADVERTISEMENT_CENTER_MEDIA_CAMPAIGNS_EDITOR_BY_ID =
	"/advertisement-center/media-campaigns/editor/:id"
export const ADVERTISEMENT_CENTER_MEDIA_CAMPAIGNS_EDITOR =
	"/advertisement-center/media-campaigns/editor"
export const ADVERTISEMENT_CENTER_MEDIA_CAMPAIGNS_SUMMARY =
	"/advertisement-center/media-campaigns/summary/:id"
export const USER_MANAGEMENT = "/administration/users"
export const ORGANIZATIONS_MANAGEMENT = "/administration/organizations"
export const PERFORMANCE = "/performance"
export const PERFORMANCE_LOYALTY_SALES_EVOLUTION =
	"performance/loyalty/sales-evolution"
export const PERFORMANCE_LOYALTY_SALES_BREAKDOWN =
	"performance/loyalty/sales-breakdown"
export const PERFORMANCE_LOYALTY_INFO_MESSAGE =
	"performance/loyalty/sales-info-message"
export const PERFORMANCE_LOYALTY_BENCHMARK = "/performance/loyalty/benchmark"
export const PERFORMANCE_LOYALTY_DETAILS = "performance/loyalty-details"
export const PERFORMANCE_EXCLUSIVITY = "/performance/exclusivity"
export const PERFORMANCE_SUBSTITUTABILITY = "/performance/substitutability"
export const NOT_FOUND = "*"
export const GROWTH_PROFILING_TREE = "/transactional/growth-profiling"
export const GROWTH_PROFILING_CUSTOMER_SEGMENTATION =
	"/transactional/growth-profiling/customers-segmentation"
export const SELLOUT_REPORT = TRANSACTIONAL
export const SELLOUT_REPORT_SUBMODULE = "/transactional/sellout-report"
export const CUSTOMER_PROFILING = "/customer-behavior/customer-profiling"
export const CUSTOMER_PROFILING_SEGMENTATION_SUMMARY =
	"/customer-behavior/customer-profiling/segmentation-summary"
export const CUSTOMER_PROFILING_DEMOGRAPHIC_SEGMENTATION =
	"/customer-behavior/customer-profiling/demographic-segmentation"
export const CUSTOMER_PROFILING_HABITS_SEGMENTATION =
	"/customer-behavior/customer-profiling/habits-segmentation"
export const CUSTOMER_PROFILING_TABLE =
	"/customer-behavior/customer-profiling/table"
export const CUSTOMER_PROFILING_CHART =
	"/customer-behavior/customer-profiling/chart"
export const CUSTOMER_PROFILING_INFORMATION =
	"/customer-behavior/customer-profiling/customer-information"
export const CUSTOMER_PROFILING_TIMELINE =
	"/customer-behavior/customer-profiling/timeline"
export const CAMPAIGN_TRACKER_SUBMODULE =
	"/advertisement-center/campaign-tracker"
export const CAMPAIGN_TRACKER_DETAILS =
	"/advertisement-center/campaign-tracker/details"
export const CUSTOMER_INFORMATION = "/customer-information"
export const VALIDATE_DATA = "/validate-data"
export const TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LEVEL =
	TRANSACTIONAL_VALUE_SHARED_MODEL + "/by-level"
export const TRANSACTIONAL_VALUE_SHARED_MODEL_BY_LOCATION =
	TRANSACTIONAL_VALUE_SHARED_MODEL + "/by-location"
export const TRANSACTIONAL_VALUE_SHARED_MODEL_BY_CHANNEL =
	TRANSACTIONAL_VALUE_SHARED_MODEL + "/by-channel"
export const TRANSACTIONAL_VALUE_SHARED_MODEL_BY_FORMAT =
	TRANSACTIONAL_VALUE_SHARED_MODEL + "/by-format"
export const TRANSACTIONAL_VALUE_SHARED_MODEL_BY_BRAND =
	TRANSACTIONAL_VALUE_SHARED_MODEL + "/by-brand"
